<template>
  <div id="product-description">
    <h4 :class="{ long: !compare }">
      <template v-if="!compare">Runstack</template>
      {{ product }}
      <span v-if="compare">{{ label }}</span>
      <span v-else>{{ description }}</span>
    </h4>

    <ul v-if="showList" :class="{ long: !compare }">
      <li v-if="compare && (product === 'enterprise' || product === 'team')">
        <i class="mdi mdi-arrow-left" /> Everything in {{ product === 'team' ? 'Free' : 'Team' }}
      </li>

      <template v-if="!compare || (product !== 'enterprise' && product !== 'team')">
        <li><i class="mdi mdi-check" /> Unlimited Applications</li>
        <li><i class="mdi mdi-check" /> Free SSL Certificates</li>
        <li><i class="mdi mdi-check" /> 24/7 Real-time Monitoring</li>
        <li><i class="mdi mdi-lifebuoy" /> 24/7/365 Support</li>
      </template>

      <template v-if="product === 'team'">
        <li><i class="mdi mdi-check" /> x4 users for collaboration</li>
        <li><i class="mdi mdi-check" /> Unlimited Projects</li>
        <li><i class="mdi mdi-check" /> DevOps Mode</li>
        <li><i class="mdi mdi-check" /> SMS Alerting</li>
      </template>

      <template v-if="product === 'enterprise'">
        <li><i class="mdi mdi-check" /> Security Audits</li>
        <li><i class="mdi mdi-check" /> Flat Price</li>
        <li><i class="mdi mdi-check" /> OneLogin</li>
        <li><i class="mdi mdi-check" /> Premium Support</li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    showList: {
      type: Boolean,
      default: true
    },
    compare: {
      type: Boolean,
      default: false
    },
    client: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    product () {
      return this.client.enterprise ? 'enterprise' : (this.client.team ? 'team' : 'free')
    },
    description () {
      switch (this.product) {
        case 'enterprise':
          return 'For mission-critical applications that are core to your business.'
        case 'team':
          return 'For people that want to collaborate and accelerate their projects.'
        default:
          return 'For people with personal or hobby projects that aren’t business-critical.'
      }
    },
    label () {
      switch (this.product) {
        case 'enterprise':
          return 'For Organizations'
        case 'team':
          return 'For Individuals and Agencies'
        default:
          return 'For Everyone'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  h4 {
    margin-top: 0;
    text-transform: capitalize;

    span {
      color: $--color-primary;
      line-height: 21px;
      font-size: 14px;
      margin: 5px 0 25px;
      font-weight: 500;
      padding: 0;
      text-transform: uppercase;
      display: block;
    }

    &:not(.long) {
      line-height: 25px;
      font-size: 2em;
      margin-bottom: 10px;
      font-weight: 400;
    }

    &.long {
      margin-bottom: 0;
      line-height: 20px;

      span {
        color: $--color-text-alt;
        text-transform: none;
        font-size: 14px;
        font-weight: 300;
        line-height: 15px;
      }
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      line-height: 24px;

      .mdi {
        color: $--color-success;
      }
    }

    &:not(.long) {
      min-height: 160px;
    }
  }
</style>
